<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Remote Inspection'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [header]="list?.title" />
      </tidy-row>
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/camera.svg'"
              class='header-size' />
            <tidy-text
              [header]="'Remote Inspection'" />
            <div></div>
          </tidy-row>
          <tidy-toggle
            [toggled]="remoteInspection"
            (toggleChanged)="remoteInspection = !remoteInspection" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Require pros to provide photos or videos so that you can remotely inspect each job.'" />
        </tidy-row>
        @if (remoteInspection) {
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row class="extra-bottom-padding">
              <tidy-radio-button
                formControlName="type"
                [form]="form.controls.type"
                [label]="'How would you like your pro to visually inspect?'"
                [items]="typeItems"
                [submitted]="submitted"
                [errorMessage]="'Please select how to inspect.'" />
            </tidy-row>
            <tidy-row>
              <tidy-radio-button
                formControlName="when"
                [form]="form.controls.when"
                [label]="'When would you like them to inspect?'"
                [items]="whenItems"
                [submitted]="submitted"
                [errorMessage]="'Please select when to inspect.'" />
            </tidy-row>
          </form>
        }
      </tidy-card>
      <tidy-button
        [text]="'Save Settings'"
        [action]="boundConfirmChange"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
